import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const bonos = [{
  id: 1,
  title: 'Diccionario Profesional de las 78 Cartas',
  image: 'https://cdn.magicpatterns.com/uploads/86TmPUA4iRQS2XyvSYQtsg/PORTADA_BONO_1.png'
}, {
  id: 2,
  title: '50 Tiradas Profesionales',
  image: 'https://cdn.magicpatterns.com/uploads/9MY6qN2SiuY4zsUTZ5bw8Q/PORTADA_BONO_2.png'
}, {
  id: 3,
  title: 'Cuaderno de Prácticas del Tarotista',
  image: 'https://cdn.magicpatterns.com/uploads/oBq5paQKrT39ogJGbc42in/PORTADA_BONO_3.png'
}];
export function Bonuses() {
  return <section className="py-20 relative z-10 bg-mystic-800/50 border-y border-gold/10" data-id="element-65">
      <div className="container mx-auto px-4" data-id="element-66">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-67">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-68">
            Además recibirás
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-69"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-70">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-mystic-900/50 rounded-2xl border border-mystic-700 hover:border-gold/50 transition-colors overflow-hidden flex flex-col group" data-id="element-71">
              <div className="relative overflow-hidden aspect-square bg-mystic-900" data-id="element-72">
                <img src={bono.image} alt={`Bono ${bono.id}: ${bono.title}`} loading="lazy" decoding="async" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-73" />
              </div>
              <div className="p-6 text-center" data-id="element-74">
                <div className="text-gold text-sm font-bold mb-2 uppercase tracking-wider" data-id="element-75">
                  Bono {bono.id}
                </div>
                <h3 className="text-lg font-semibold text-white" data-id="element-76">
                  {bono.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}